import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Политика конфиденциальности</h1>
      <p>Дата обновления: 2025-03-12</p>
      <p>
        1. Общие положения<br />
        Настоящая Политика конфиденциальности (далее – «Политика») регулирует порядок обработки и защиты персональных данных
        посетителей сайта VIKTOR KALYAKIN https://kalyakin.site/ и его субдомены (далее – «Сайт»).
      </p>
      <p>
        2. Сбор и обработка данных<br />
        Мы используем сервис Яндекс Метрика для анализа поведения пользователей, улучшения удобства и качества работы Сайта. В процессе
        работы автоматически собираются:<br />
        - IP-адрес (в анонимизированной форме),<br />
        - Тип устройства и браузера,<br />
        - Посещённые страницы и действия на сайте,<br />
        - Источник перехода на сайт.<br />
        Данные обрабатываются анонимно и не используются для идентификации личности.
      </p>
      <p>
        3. Использование cookies<br />
        На сайте используются cookies, которые позволяют запоминать настройки пользователя и собирать статистику. Вы можете отключить
        cookies в настройках браузера, но это может повлиять на корректную работу некоторых функций сайта.
      </p>
      <p>
        4. Передача данных третьим лицам<br />
        Мы не передаём данные третьим лицам, за исключением случаев, предусмотренных законодательством.
      </p>
      <p>
        5. Отказ от сбора данных<br />
        Если вы не хотите, чтобы ваш визит на сайт учитывался в Яндекс Метрике, вы можете:<br />
        - Отключить cookies в настройках браузера.<br />
        - Установить расширение для браузера от Яндекса, блокирующее передачу данных.
      </p>
      <p>
        6. Контакты<br />
        Если у вас есть вопросы по обработке данных, свяжитесь с мной:<br />
        Email: admin@kalyakin.site
      </p>
    </div>
  );
};

export default PrivacyPolicy;
